import * as React from 'react';
import SwitchVisual from '../../General/SwitchVisual';
import Select from 'react-select';
import { connect } from 'react-redux';
import {
    fetchMarcas,
    fetchCategorias,
    fetchPublicaciones,
    setFiltroPublicacion,
    fetchPublicacionesEncabezado
} from '../../../actions/publicacionesActions';
import { fetchSellersFilter } from '../../../actions/sellersActions';
import { customStyle } from '../../../template/CustomStyle';
import { DropDownArrow } from "../../../template/CustomStyle";
import { filtroMedioMes } from '../../../utilities/fechasFiltro';

const fechaFiltro = filtroMedioMes();

class PublicacionesFilter extends React.Component {
    constructor(props) {
        super(props);
        const estadoGuardado = this.props.filtroPublicaciones.estado;
        const idPublicacionGuardada = (this.props.filtroPublicaciones.idPublicacion || "").toString().trim();
        let estado = this.props.filtroPublicaciones.estadoLabel || this.switchEstado(estadoGuardado);

        this.state = {
            skuSeller: this.props.filtroPublicaciones.skuSeller,
            marca: {
                label: this.props.filtroPublicaciones.marcaLabel,
                value: this.props.filtroPublicaciones.value
            },
            categoria: {
                label: this.props.filtroPublicaciones.categoriaLabel,
                value: this.props.filtroPublicaciones.categoria
            },
            seller: {
                label: this.props.filtroPublicaciones.idSellerLabel,
                value: this.props.filtroPublicaciones.idSeller
            },
            estado: {
                label: estado,
                value: this.props.filtroPublicaciones.estado
            },
            idTipoPublicacion: {
                label: this.props.filtroPublicaciones.idTipoPublicacionLabel,
                value: this.props.filtroPublicaciones.idTipoPublicacion
            },
            sinStock: {
                label: this.props.filtroPublicaciones.sinStockLabel,
                value: this.props.filtroPublicaciones.sinStock
            },
            fechaPubDesde: this.props.filtroPublicaciones.fechaPubDesde ?? fechaFiltro.desde,
            fechaPubHasta: this.props.filtroPublicaciones.fechaPubHasta ?? fechaFiltro.hasta,
            skuMarket: this.props.filtroPublicaciones.skuMarket,
            variaciones: [],
            tipoPublicacion: [],
            idPublicacion: this.props.filtroPublicaciones.idPublicacion,
            switchInternacional: this.props.filtroPublicaciones.internacional === true,
            estadoBloqueadoPorRespuesta: (estadoGuardado || "").toString().toLowerCase() === "eliminado" && idPublicacionGuardada !== "",
        }
    }

    componentDidUpdate(prevProps) {
        const resultadosPrevios = this.getResultadosPublicaciones(prevProps.publicaciones);
        const resultadosActuales = this.getResultadosPublicaciones(this.props.publicaciones);

        if (resultadosPrevios === resultadosActuales) return;
        if (!resultadosActuales.length) return;

        const estadoResultado = Number(resultadosActuales[0]?.estado);
        const idPublicacionActual = (this.state.idPublicacion || "").toString().trim();

        if (estadoResultado === 5 && idPublicacionActual !== "") {
            if (this.state.estado?.value !== "eliminado" || !this.state.estadoBloqueadoPorRespuesta) {
                this.setState({
                    estado: { value: "eliminado", label: "ELIMINADO" },
                    estadoBloqueadoPorRespuesta: true
                });

                if (this.props.filtroPublicaciones?.estado !== "eliminado") {
                    this.props.setFiltroPublicacion({
                        ...this.props.filtroPublicaciones,
                        estado: "eliminado",
                        estadoLabel: "ELIMINADO",
                        idPublicacion: idPublicacionActual
                    });
                }
            }
            return;
        }
    }

    getResultadosPublicaciones = (publicaciones) => {
        if (Array.isArray(publicaciones)) return publicaciones;
        if (Array.isArray(publicaciones?.elementos)) return publicaciones.elementos;
        return [];
    }


    onSelectSearchInputCategorias = (descripcion) => {
        this.props.fetchCategorias(descripcion);
    };

    onSelectSearchInputMarcas = (descripcion) => {
        this.props.fetchMarcas(descripcion);
    };

    onSelectSearchInputSellers = (descripcion, action) => {
        // Solo buscar cuando el usuario escribe, no cuando selecciona
        if (action.action === 'input-change') {
            this.props.fetchSellersFilter({ 
                Descripcion: descripcion,
                Page: 1,
                PageSize: 100
            });
        }
    }

    selectSearchHandler = (options, config) => {
        this.setState({ [config.name]: options });
    };

    onFilter = (event) => {
        event.preventDefault();

        const skuSellerValue = this.state.skuSeller || "";
        const skuMarketValue = this.state.skuMarket || "";
        const idPublicacionValue = this.state.idPublicacion || "";
        const isSearchBySku = skuSellerValue !== "" || skuMarketValue !== "";
        const isSearchById = idPublicacionValue !== "";

        // Si se busca por SKU o por ID de publicación, no enviar fechas
        const shouldNullDates = isSearchBySku || isSearchById;

        const internacionalActivo = this.state.switchInternacional === true;

        let filtroPublicacion = {
            estado: this.state.estado.value,
            estadoLabel: this.state.estado.label,
            marca: this.state.marca.value,
            marcaLabel: this.state.marca.label,
            categoria: this.state.categoria.value,
            categoriaLabel: this.state.categoria.label,
            idSeller: this.state.seller.value,
            idSellerLabel: this.state.seller.label,
            idTipoPubli: this.state.idTipoPublicacion.value,
            idTipoPublicacionLabel: this.state.idTipoPublicacion.label,
            skuSeller: this.state.skuSeller,
            skuMarket: this.state.skuMarket,

            fechaPubDesde: shouldNullDates ? null : this.state.fechaPubDesde,
            fechaPubHasta: shouldNullDates ? null : this.state.fechaPubHasta,

            sinStock: this.state.sinStock?.value,
            sinStockLabel: this.state.sinStock?.label,
            idPublicacion: this.state.idPublicacion,

        };

        if (internacionalActivo) {
            filtroPublicacion.internacional = true;
        }

        if (!this.props.allowSearchBySeller) {
            filtroPublicacion.idSeller = this.props.idSeller;
        }


        this.props.setFiltroPublicacion(filtroPublicacion);

        const exportPayload = {
            idSeller: isNaN(parseInt(filtroPublicacion.idSeller)) ? null : parseInt(filtroPublicacion.idSeller),
            fechaPubDesde: shouldNullDates ? null : filtroPublicacion.fechaPubDesde,
            fechaPubHasta: shouldNullDates ? null : filtroPublicacion.fechaPubHasta,
            categoria: isNaN(parseInt(filtroPublicacion.categoria)) ? null : parseInt(filtroPublicacion.categoria),
            marca: isNaN(parseInt(filtroPublicacion.marca)) ? null : parseInt(filtroPublicacion.marca),
            estado: filtroPublicacion.estado,
            skuSeller: filtroPublicacion.skuSeller,
            skuMarket: filtroPublicacion.skuMarket,
            sinStock: filtroPublicacion.sinStock === "" ? null : filtroPublicacion.sinStock,
            idPublicacion: filtroPublicacion.idPublicacion,
            idTipoPubli: filtroPublicacion.idTipoPubli,
        };

        if (internacionalActivo) {
            exportPayload.internacional = true;
        }


        if (typeof this.props.requestParaExportar === 'function') {
            this.props.requestParaExportar(exportPayload);
        } else {
            // eslint-disable-next-line no-console
            console.warn('requestParaExportar no está definido o no es función');
        }
    };

    onClearFilter = (event) => {
        event.preventDefault();
        this.props.setInitialPage();

        let params = {
            idSeller: this.props.allowSearchBySeller ? null : this.props.idSeller,
            fechaPubHasta: fechaFiltro.hasta,
            fechaPubDesde: fechaFiltro.desde
        };

        if (this.props.shouldFetchOnClear) {
            this.props.fetchPublicacionesEncabezado(params);
        }

        this.props.setFiltroPublicacion(params);
        localStorage.removeItem("pagina");

        this.setState({
            marca: { label: "", value: "" },
            categoria: { label: "", value: "" },
            estado: { label: "", value: "" },
            estadoBloqueadoPorRespuesta: false,
            seller: { label: "", value: "" },
            skuSeller: "",
            skuMarket: "",
            fechaPubDesde: fechaFiltro.desde,
            fechaPubHasta: fechaFiltro.hasta,
            idTipoPublicacion: { label: "", value: "" },
            sinStock: { label: "", value: "" },
            idPublicacion: "",
            switchInternacional: false
        });

        if (this.props.onClearCantidad) {
            this.props.onClearCantidad();
        }
    };

    handleChange = (event) => {
        const { name, value } = event.target;

        this.setState({ [name]: value }, () => {
            const trimmed = (value || "").toString().trim();

            if ((name === "skuSeller" || name === "skuMarket") && trimmed !== "") {
                this.setState({
                    idPublicacion: "",
                    marca: { label: "", value: "" },
                    categoria: { label: "", value: "" },
                    seller: { label: "", value: "" },
                    estado: { label: "", value: "" },
                    idTipoPublicacion: { label: "", value: "" },
                    sinStock: { label: "", value: "" },
                    fechaPubDesde: null,
                    fechaPubHasta: null
                });
                return;
            }

            if (name === "idPublicacion" && trimmed !== "") {
                this.setState({
                    skuSeller: "",
                    skuMarket: "",
                    marca: { label: "", value: "" },
                    categoria: { label: "", value: "" },
                    seller: { label: "", value: "" },
                    estado: { label: "", value: "" },
                    idTipoPublicacion: { label: "", value: "" },
                    sinStock: { label: "", value: "" },
                    fechaPubDesde: "",
                    fechaPubHasta: "",
                    estadoBloqueadoPorRespuesta: false
                });
                return;
            }

            if (name === "fechaPubDesde") {
                this.setState({ fechaPubDesde: value });
            }

            if (name === "fechaPublicacionHasta") {
                this.setState({ fechaPubHasta: value });
            }
        });
    };

    mapVariaciones = () => {
        let variaciones = [];
        if (this.props.variaciones) {
            this.props.variaciones.forEach(variacion =>
                variaciones.unshift({
                    label: this.switchEstado(variacion.descripcion),
                    value: variacion.descripcion
                })
            );
        }

        if (
            this.state.estado?.value &&
            !variaciones.some(item => item.value === this.state.estado.value)
        ) {
            variaciones.unshift({
                value: this.state.estado.value,
                label: this.state.estado.label
            });
        }

        this.setState({ variaciones: variaciones });
    }

    mapTipoPublicacion = () => {
        let tipoPublicacion = [];
        if (this.props.tipoPublicacion) {
            this.props.tipoPublicacion.forEach(item =>
                tipoPublicacion.unshift({
                    label: item.descripcion,
                    value: item.codigo
                })
            );
        }
        this.setState({ tipoPublicacion });
    };

    switchEstado = (estado) => {
        switch (estado) {
            case "activo":
                return "ACTIVO";
            case "pendiente_activacion":
                return "PENDIENTE";
            case "pausado":
                return "PAUSADO";
            case "en_revision":
                return "EN REVISIÓN";
            case "eliminado":
            case "Eliminado":
                return "ELIMINADO";
            default:
                return estado;
        }
    };

    mapSellers = () => {
        // SIEMPRE cargar sellers cuando se abre el dropdown
        // Esto limpia cualquier filtro previo del dashboard u otras vistas
        this.props.fetchSellersFilter({
            Descripcion: "",
            Page: 1,
            PageSize: 100
        });
    }

    render() {

        const { loadingPublicaciones, allowSearchBySeller, loadingExport } = this.props;

        // Construir lista de sellers sin agregar "Todos" aquí (se maneja en el estado local)
        let listaSeller = (this.props.sellers || []).map(item => ({
            label: item.label,
            value: item.value ? item.value.toString() : ""
        }));
        
        // Agregar opción "Todos" si no está ya en la lista
        if (listaSeller.length > 0 && listaSeller[0]?.value !== "") {
            listaSeller.unshift({ value: "", label: "Todos" });
        }

        const listaCategoria = (this.props.categorias || []).map(item => ({
            label: item.label,
            value: item.value.toString()
        }));

        const listaMarca = (this.props.marcas || []).map(item => ({
            label: item.label,
            value: item.value.toString()
        }));

        const stockOpciones = [
            { value: undefined, label: "Todos" },
            { value: true, label: "Sin Stock" },
            { value: false, label: "Con Stock" }
        ];

        const classIsModerador = allowSearchBySeller ? "col-lg-2" : "col-lg-3";

        const skuSellerValue = this.state.skuSeller || "";
        const skuMarketValue = this.state.skuMarket || "";
        const idPublicacionValue = this.state.idPublicacion || "";

        const isSearchBySku = skuSellerValue !== "" || skuMarketValue !== "";
        const isSearchById = idPublicacionValue !== "";
        const isFiltering = isSearchBySku || isSearchById;
        const isEstadoDisabled = isFiltering || this.state.estadoBloqueadoPorRespuesta;

        return (
            <div className="card card-body filter-card">
                <form
                    className="row form-material"
                    onSubmit={this.onFilter}
                    onReset={this.onClearFilter}
                >
                    <div className={classIsModerador}>
                        <label className="label-oscura">ID Publicación</label>
                        <input
                            type="text"
                            name="idPublicacion"
                            onChange={this.handleChange}
                            value={this.state.idPublicacion}
                            className="form-control"
                            disabled={isSearchBySku}
                        />
                    </div>

                    {allowSearchBySeller &&
                        <div className={classIsModerador}>
                            <label className="label-oscura">Seller</label>
                            <Select
                                name="seller"
                                value={this.state.seller}
                                options={listaSeller}
                                onChange={this.selectSearchHandler}
                                onMenuOpen={this.mapSellers}
                                onInputChange={this.onSelectSearchInputSellers}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                styles={customStyle}
                                isDisabled={isFiltering}
                            />
                        </div>
                    }
                    <div className={classIsModerador}>
                        <label className="label-oscura">Sku Seller</label>
                        <input
                            type="text"
                            name="skuSeller"
                            onChange={this.handleChange}
                            value={this.state.skuSeller}
                            className="form-control"
                            disabled={isSearchById}
                        />
                    </div>

                    <div className={classIsModerador}>
                        <label className="label-oscura">Sku Market</label>
                        <input
                            type="text"
                            name="skuMarket"
                            onChange={this.handleChange}
                            value={this.state.skuMarket}
                            className="form-control"
                            disabled={isSearchById}
                        />
                    </div>

                    <div className={classIsModerador}>
                        <label className="label-oscura">Marca</label>
                        <Select
                            name="marca"
                            value={this.state.marca}
                            options={listaMarca}
                            onInputChange={this.onSelectSearchInputMarcas}
                            onChange={this.selectSearchHandler}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            styles={customStyle}
                            isDisabled={isFiltering}
                        />
                    </div>

                    <div className={classIsModerador}>
                        <label className="label-oscura">Categoria</label>
                        <Select
                            name="categoria"
                            value={this.state.categoria}
                            options={listaCategoria}
                            onInputChange={this.onSelectSearchInputCategorias}
                            onChange={this.selectSearchHandler}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            styles={customStyle}
                            isDisabled={isFiltering}
                        />
                    </div>

                    <div className={classIsModerador}>
                        <label className="label-oscura">Estado</label>
                        <Select
                            name="estado"
                            options={this.state.variaciones}
                            onChange={this.selectSearchHandler}
                            value={this.state.estado}
                            onMenuOpen={this.mapVariaciones}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            styles={customStyle}
                            isDisabled={isEstadoDisabled}
                        />
                    </div>

                    <div name="fechaPubDesde" className={classIsModerador} onMouseEnter={this.handleChange}>
                        <label className="label-oscura">Fecha desde</label>
                        <input
                            type="date"
                            name="fechaPubDesde"
                            className="form-control"
                            onChange={this.handleChange}
                            value={this.state.fechaPubDesde}
                            disabled={isFiltering}
                        />
                    </div>

                    <div className={classIsModerador} name="fechaPublicacionHasta" onMouseEnter={this.handleChange}>
                        <label className="label-oscura">Fecha hasta</label>
                        <input
                            type="date"
                            name="fechaPublicacionHasta"
                            className="form-control"
                            onChange={this.handleChange}
                            value={this.state.fechaPubHasta}
                            disabled={isFiltering}
                        />
                    </div>

                    {allowSearchBySeller &&
                        <div className="col-lg-2">
                            <label className="label-oscura">Tipo publicación</label>
                            <Select
                                name="idTipoPublicacion"
                                options={this.state.tipoPublicacion}
                                onChange={this.selectSearchHandler}
                                value={this.state.idTipoPublicacion}
                                onMenuOpen={this.mapTipoPublicacion}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                placeholder=""
                                styles={customStyle}
                                isDisabled={isFiltering}
                            />
                        </div>
                    }

                    <div className={classIsModerador}>
                        <label className="label-oscura">Stock</label>
                        <Select
                            name="stock"
                            options={stockOpciones}
                            onChange={(e) => this.setState({ sinStock: e })}
                            value={this.state.sinStock}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            placeholder=""
                            styles={customStyle}
                            isDisabled={isFiltering}
                        />
                    </div>

                    {/* Switch Internacional en su propio div */}
                    <div className={classIsModerador}>
                        <label className="label-oscura d-block">&nbsp;</label>
                        <SwitchVisual
                            label="Internacional"
                            labelPosition="left"
                            checked={this.state.switchInternacional}
                            onChange={checked => this.setState({ switchInternacional: this.normalizeChecked(checked) })}
                            disabled={isFiltering}
                            labelStyle={{ fontWeight: 600, color: '#525f7f', fontSize: '0.9rem', marginBottom: '0.4rem' }}
                            labelClassName="label-oscura"
                        />
                        <small style={{ color: this.state.switchInternacional ? 'green' : 'red', marginTop: '2px', fontWeight: 'bold', fontSize: '10px' }}>
                            {this.state.switchInternacional ? 'Activo' : 'Inactivo'}
                        </small>
                    </div>

                    <div className="row p-10">
                        <div className="col-12 col-sm-6 text-center text-sm-end mt-sm-3">
                            <button
                                className="btn d-inline btn-sm btn-grey m-r-10"
                                disabled={loadingExport}
                                type="submit"
                            >
                                Buscar
                            </button>
                            <button className="btn btn-sm btn-grey d-inline" type="reset">
                                Limpiar
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    publicaciones: state.publicaciones.publicaciones,
    loadingPublicaciones: state.publicaciones.loadingPublicaciones,
    marcas: state.publicaciones.marcas,
    categorias: state.publicaciones.categorias,
    variaciones: state.publicaciones.variacionesPublicacion,
    sellers: state.sellers.filteredSellers,
    idSeller: state.general.idSeller,
    tipoPublicacion: state.tiposPublicacion.tiposPublicaciones.elementos,
    filtroPublicaciones: state.publicaciones.filtroPublicaciones,
});

export default connect(mapStateToProps, {
    fetchMarcas,
    fetchCategorias,
    fetchPublicaciones,
    fetchSellersFilter,
    setFiltroPublicacion,
    fetchPublicacionesEncabezado,
    // getSellerDesplegable
})(PublicacionesFilter);
